<template>
<div v-bind:style="{'display': display ? '' : 'none'}">
  <div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>登録店舗</th>
            <th>顧客番号</th>
            <th>電話番号</th>
            <th>氏名(カナ)</th>
            <th>氏名</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="c in ownCustomers" @click="select(c)">
            <td>{{ c.shopName }}({{ c.shopCode }})</td>
            <td>{{ c.account }}</td>
            <td>{{ c.phoneNumber }}</td>
            <td>{{ c.familyNameKana }} {{ c.firstNameKana }}</td>
            <td>{{ c.familyName }} {{ c.firstName }}</td>
          </tr>
          <tr v-for="c in otherCustomers" @click="select(c)">
            <td>{{ c.shopName }}({{ c.shopCode }})</td>
            <td>{{ c.account }}</td>
            <td>{{ c.phoneNumber }}</td>
            <td>{{ c.familyNameKana }} {{ c.firstNameKana }}</td>
            <td>{{ c.familyName }} {{ c.firstName }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-default pull-left" @click="back">戻る</button>
  </div>
</div>
</template>


<script lang="babel">
export default {
  name: 'reservation-table-modal-form-customer-finder',
  props: {
    display: {
      type: Boolean,
      default: true,
    },
    shop: {
      type: Object,
      required: true,
    },
    shops: {
      type: Array,
      required: true,
    },
  },
  filters: {
    parseAccount (value) {
      if (!value) {
        return value
      }
      let shop = null
      let code = value
      if (code.length > 4) {
        this.shops.forEach( v => {
          if (value.startsWith(v.code)) {
            shop = v
            code = code.slice(v.code.length)
            return false
          }
        })
      }
      if (shop) {
        return shop.name + '(' + shop.code + ') ' + code
      }
      return code
    }
  },
  events: {
    'customer-finder-find': function (options) {
      this.apiGet(
          '/api/1.0/customers/',
          Object.assign({}, options, {page_size: 30}),
          {shopAs: this.shop.pk}
      ).then(response => {
        this.customers = response.body.results
      })
    }
  },
  data() {
    return {
      customers: [],
    }
  },
  computed: {
    ownCustomers() {
      return this.customers.filter(x => x.shop === this.shop.pk)
    },
    otherCustomers() {
      return this.customers.filter(x => x.shop !== this.shop.pk)
    },
  },
  methods: {
    select(customer) {
      this.$dispatch('switch-modal', 'edit', [
          {
            name: 'select-customer',
            options: {
              customer: customer
            },
          }
      ])
    },
    back() {
      this.$dispatch('switch-modal', 'edit')
    }
  },
  mixins: [
    require('mixin/api-client.vue'),
  ],
}
</script>



// WEBPACK FOOTER //
// customer-finder.vue?02f429b6